export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a2871954439c0fceceac6fa8ed17d9d5e805ce9a&name=revalidateCommunity!'